import { FC, useState, useEffect } from 'react'

import AudioPlayer from 'components/parts/audio-player/audio-player'
import ArticleTitle from 'components/articles/parts/article-title/article-title'
import AuthorLector from 'components/parts/author-lector/author-lector'
import useLectorsSubscription from 'hooks/useLectorsSubscription'

import { getAxiosSingle } from 'pages/api/axios'
import { PLACEFLAG_ARTICLE } from 'constants/analytic-data'
import { IMaterial } from 'constants/types/webinar.types'
import { URL_LIST } from 'constants/url'

import styles from './webinar-listen.module.scss'

interface IWebinarListen {
  dataset: IMaterial
}

const WebinarListen: FC<IWebinarListen> = ({ dataset }) => {
  const [audioData, setAudioData] = useState({ duration: 0, audioLink: '' })
  const { lectors, subscribeLector } = useLectorsSubscription(dataset.Lecturs, PLACEFLAG_ARTICLE)

  useEffect(() => {
    const getAudio = async () => {
      const result = await getAxiosSingle(`${URL_LIST.FORMAT_WEBINAR_AUDIO}/${dataset.id}`)
      setAudioData(result)
    }
    getAudio()
  }, [])

  return (
    <>
      <ArticleTitle
        themes={dataset.Themes}
        title={dataset.name}
        startDate={dataset.startDate}
        showLikeShare
      />
      <div className={styles.audio}>
        <AudioPlayer src={audioData.audioLink} name={dataset.name} />
      </div>
      <div className={styles.lectors}>
        <div className={styles.lectorTitle}>Лекторы </div>
        <div className={styles.lectorsWrapper}>
          {lectors &&
            lectors.map((lectur) => (
              <AuthorLector
                key={lectur.id}
                lectorData={{ ...lectur, small: true }}
                subscribeLector={subscribeLector}
                modificator={styles.author}
                withLink
              />
            ))}
        </div>
      </div>
    </>
  )
}

export default WebinarListen
